import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { useGetAdditionalServices } from 'hooks/useGetAdditionalServices';
import { useGetPrices } from 'hooks/useGetPrices';
import hash from 'object-hash';
import { useTranslation } from 'react-i18next';
import { OrderType } from 'types/OrderType';
import { UFOPart } from 'types/UFOTypes';
import { INSTALLATION_SCODES, INSTALLATION_TPMS, PQL_MOUNTING_WHEEL } from 'utils/constantValues';
import { getMspn } from 'utils/getMspn';
import { CommonPricesParamsType } from 'utils/getPricesCallCommonParams';
import { InstallationDetail } from './InstallationDetails';

interface GroupedInstallationsProps {
  tire: UFOPart;
  installationsOptions: SelectedMountingOptionType[];
  commonPricesParams: CommonPricesParamsType;
  singleColumn?: boolean;
  order?: OrderType;
  relatedToCode?: string;
  isMobile: boolean;
}

export type SelectedMountingOptionType = {
  installation: boolean | null;
  wheels: boolean;
  tpms: boolean;
  added: boolean;
  qty: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  related_to?: string;
};

export function GroupedInstallations(props: GroupedInstallationsProps) {
  const { t } = useTranslation();
  const { tire, installationsOptions, commonPricesParams, singleColumn, order, relatedToCode, isMobile } = props;
  const [reqPqlForm, setReqPqlForm] = useState(false);

  const wheelMspn = PQL_MOUNTING_WHEEL;
  const installationsScodes = INSTALLATION_SCODES;
  const tpmsMspn = INSTALLATION_TPMS;

  const additionalServicesResp = useGetAdditionalServices({
    with_service_mspn: true,
    fleet_id: commonPricesParams.fleet_id,
    dealer_id: commonPricesParams.provider_id,
    isMobile,
    query: PQL_MOUNTING_WHEEL,
  });

  const wheelIsPql: boolean =
    additionalServicesResp?.data?.addlServices.find((service) => service.mspn === wheelMspn)?.ispql || false;

  const pricesResponse = useGetPrices(
    order || wheelIsPql === undefined
      ? null
      : {
          ...commonPricesParams,
          parts: [
            ...tire.service_mspn.map((service) => ({ mspn: service, qty: 1, is_pql: false })),

            { mspn: wheelMspn, qty: 1, is_pql: wheelIsPql },
          ],
        },
  );

  let tpmsPrice;
  let wheelsPrice;
  let installation;

  if (order && relatedToCode) {
    tpmsPrice = order.parts?.find((price) => getMspn(price) === tpmsMspn);
    wheelsPrice = order.parts?.find((price) => price.related_to === relatedToCode && getMspn(price) === wheelMspn);
    installation = order.parts?.find((price) => installationsScodes.includes(getMspn(price) as string));
  } else {
    tpmsPrice = pricesResponse?.data?.parts?.find((price) => getMspn(price) === tpmsMspn);
    wheelsPrice =
      pricesResponse?.data?.parts?.find((price) => getMspn(price) === wheelMspn && price.unitAmout) ||
      pricesResponse?.data?.pqlParts?.find((price) => getMspn(price) === wheelMspn);
    installation = pricesResponse?.data?.parts?.find((price) => installationsScodes.includes(getMspn(price) as string));
  }
  return (
    <>
      {installationsOptions.map((option, index) => (
        <>
          {option.added && (
            <Grid item xs={singleColumn ? 12 : 6} key={hash(option)}>
              <InstallationDetail
                reqPqlForm={reqPqlForm}
                setReqPqlForm={setReqPqlForm}
                relatedTireMspn={tire.mspn}
                readonly
                option={option}
                onOpen={() => {}}
                comboNumber={index + 1}
                prices={{ installation, tpms: tpmsPrice, wheels: wheelsPrice }}
                qtySelectorComponent={
                  <div
                    style={{
                      marginLeft: 16,
                      height: 26,
                      width: 60,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {t('Qty: {{qty}}', {qty: option.qty})}
                  </div>
                }
              />
            </Grid>
          )}
        </>
      ))}
    </>
  );
}
